/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import { PRODUCT_QUERY_PARAM_MAP } from "@/pages/support/TechnicalSupportComponents/constants";

/**
 * The ONE fixed list still compared against the live catalogue, kept here so
 * the shared hook does not import from a page folder.
 *
 * PRODUCT_QUERY_PARAM_MAP is a compatibility table for links already published
 * in emails, on the internet and inside the desktop products. It is frozen: no
 * new entries, because a product's own slug covers every product added from now
 * on (decision 7.6.4).
 *
 * The four curated product lists that used to be checked this way are all gone
 * — an administrator sets a flag per product instead (PR-1, and Session 423 for
 * the header menu), so there is nothing left to drift. HEADER_HIDDEN_PRODUCTS
 * was the last of them; the products the header does not offer are now read out
 * of the catalogue itself by toHeaderHiddenProductNames().
 */
export const PRODUCT_QUERY_PARAM_MAP_VALUES: readonly string[] = Object.values(
  PRODUCT_QUERY_PARAM_MAP,
);
